import sfxDownloadLogClient from '@/api/sfxDownloadLog.js'

// initial state
const state = {
  sfxDownloadLogEntries: []
}

// getters
const getters = {
  sfxDownloadLogEntries (state) {
    return state.sfxDownloadLogEntries
  }
}

// actions
const actions = {
  fetchLogEntries: (context) => {
    return sfxDownloadLogClient.listAll()
      .then((data) => {
        context.commit(SET_PSE_DOWNLOAD_LOG, data)
        return data
      })
  },

  clearLogEntries: (context) => {
    context.commit(SET_PSE_DOWNLOAD_LOG, [])
  }
}

// mutations
const SET_PSE_DOWNLOAD_LOG = 'SET_PSE_DOWNLOAD_LOG'

const mutations = {
  [SET_PSE_DOWNLOAD_LOG]: (state, payload) => {
    state.sfxDownloadLogEntries = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
